import axios from 'axios';
import * as endpoints from './endpoints';

export function getEffectivePermissionsForUser(userId) {
  return axios.get(`${endpoints.USER_PERMISSIONS}/${userId}`, endpoints.headers());
}

export function updatePermissionsForUser(userId, permission) {
  return axios.put(`${endpoints.USER_PERMISSIONS}/${userId}`, permission, endpoints.headers());
}

export function resetPermissionsToDefaultForUser(userId) {
  return axios.post(`${endpoints.USER_PERMISSIONS}/${userId}/reset`, {}, endpoints.headers());
}
